import { TopBanner } from 'ui/components';

export const TopBannerFeature: React.FC<Umbraco.TopBanner> = ({ content }) => <TopBanner {...content?.properties} />;
